import { render, staticRenderFns } from "./MapDataViewerLegend.vue?vue&type=template&id=72f85f39&scoped=true&"
import script from "./MapDataViewerLegend.vue?vue&type=script&lang=js&"
export * from "./MapDataViewerLegend.vue?vue&type=script&lang=js&"
import style0 from "./MapDataViewerLegend.vue?vue&type=style&index=0&id=72f85f39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f85f39",
  null
  
)

export default component.exports